import { NgModule } from '@angular/core';
import { hash } from './hash.pipe';
import { newLine } from './newLine.pipe';
@NgModule({
    declarations: [hash, newLine],
    exports: [hash, newLine]
})
export class PipesModule { }
